import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ProcessStepRecordingDisplaySchema } from '../../entities/process-step-recording/process-step-recording.schema';
export const ResumeProcessStepRecordingRequestSchema = z.void();
export const ResumeProcessStepRecordingResponseSchema = z.object({
    processStepRecording: ProcessStepRecordingDisplaySchema.nullable()
});
export const ResumeProcessStepRecordingErrorSchema = BaseErrorSchema;

//# sourceMappingURL=resume-process-step-recording.schema.js.map